import {
  SET_INVOICES_DATA,
  SET_INVOICES_FETCH_DATA_ERROR,
  SET_INVOICES_FETCH_LOADING,
  SET_INVOICES_FILTERS,
  SET_INVOICES_FETCH_METRICS_LOADING,
  SET_INVOICES_METRICS_DATA,
  SET_INVOICES_FETCH_METRICS_DATA_ERROR,
  SET_INVOICES_PAGINATION,
} from 'src/common/actions/constants';
import { fetchAllInvoices, fetchInvoiceBucketMetrics } from './Invoices.api';
import { InvoiceBucketLabelMap } from './Invoices.utils';

export const fetchInvoiceBucketMetricsData = (data) => async (dispatch, getState) => {
  dispatch({
    type: SET_INVOICES_FETCH_METRICS_LOADING,
    data: true,
  });

  const { invoices } = getState();

  const {
    search,
    bucket,
    timeFilters,
    movementType,
    invoiceStatus,
    vendorIdsToFilter,
  } = invoices?.filters || {};

  let body: any = {
    bucketIds: Object.keys(InvoiceBucketLabelMap),
  };

  if (search?.searchBy && search?.searchValue) {
    const value = search.searchBy === 'consignmentReferenceNumber' ?
      search.searchValue?.toUpperCase()?.trim() : search.searchValue?.trim();
    body = {
      ...body,
      vendorIdsToFilter,
      [`${search.searchBy}`]: [value],
    };
  } else {
    body = {
      ...body,
      timeFilters,
      movementType,
      invoiceStatus,
      vendorIdsToFilter,
    };
  }

  const response = await fetchInvoiceBucketMetrics(body);
  if (response.isSuccess) {
    dispatch({
      type: SET_INVOICES_METRICS_DATA,
      data: response.data,
    });
  } else {
    dispatch({
      type: SET_INVOICES_FETCH_METRICS_DATA_ERROR,
      data: response.errorMessage,
    });
  }
  dispatch({
    type: SET_INVOICES_FETCH_METRICS_LOADING,
    data: false,
  });
};

export const fetchInvoiceData = (data) => async (dispatch, getState) => {
  dispatch({
    type: SET_INVOICES_FETCH_LOADING,
    data: true,
  });

  const { invoices } = getState();
  const paginationParams = invoices?.pagination || {};

  const {
    search,
    bucket,
    timeFilters,
    movementType,
    invoiceStatus,
    vendorIdsToFilter,
  } = invoices?.filters || {};

  let body: any = {
    ...paginationParams,
    bucket,
  };

  if (search?.searchBy && search?.searchValue) {
    const value = search.searchBy === 'consignmentReferenceNumber' ?
      search.searchValue?.toUpperCase()?.trim() : search.searchValue?.trim();
    body = {
      ...body,
      timeFilters,
      vendorIdsToFilter,
      [`${search.searchBy}`]: value,
    };
  } else {
    body = {
      ...body,
      timeFilters,
      movementType,
      invoiceStatus,
      vendorIdsToFilter,
    };
  }

  const response = await fetchAllInvoices(body);
  if (response.isSuccess) {
    dispatch({
      type: SET_INVOICES_DATA,
      data: response.data,
    });
    dispatch({
      type: SET_INVOICES_PAGINATION,
      data: {
        ...paginationParams,
        isNextPresent: response.data?.is_next_present,
      },
    });
  } else {
    dispatch({
      type: SET_INVOICES_FETCH_DATA_ERROR,
      data: response.errorMessage,
    });
  }
  dispatch({
    type: SET_INVOICES_FETCH_LOADING,
    data: false,
  });
};

export const setPagination = (data) => (dispatch) => {
  dispatch({
    type: SET_INVOICES_PAGINATION,
    data,
  });
  dispatch(fetchInvoiceData(data));
};

export const setInvoiceFilters = (data) => (dispatch, getState) => {
  let shouldFetchData = true;

  // to avoid api call when searchBy is changed without searchValue
  if (data?.search?.searchBy && !data?.search?.searchValue) {
    const { invoices } = getState();
    const { search } = invoices.filters;
    if (!search.searchValue) {
      shouldFetchData = false;
    }
  }

  dispatch({
    type: SET_INVOICES_FILTERS,
    data,
  });

  if (shouldFetchData) {
    dispatch(fetchInvoiceData(data));
    dispatch(fetchInvoiceBucketMetricsData(data));
  }
};
